import { AllergenLogic } from 'enums/allergenLogic';
import * as Icon from 'types/Icon/Icon';

export type Type = {
	display: boolean;
	iconSvgUrl: string | null;
	id: string;
	logic: AllergenLogic;
	name: string;
};

export function create(): Type {
	return {
		display: false,
		iconSvgUrl: null,
		id: '',
		logic: AllergenLogic.Negative,
		name: '',
	};
}

export function mapToIcon(obj: Type, allergensUserSet: Set<string>): Icon.Type | null {
	if (obj.display || allergensUserSet.has(`${obj.id}_${obj.logic}`)) {
		return {
			name: obj.name,
			iconSvgUrl: obj.iconSvgUrl,
		};
	}
	return null;
}
